import React, { useState, useEffect } from 'react';

interface DelayedRenderProps {
  children: React.ReactNode;
  delay?: number;
}

export const DelayedMount = ({ children, delay = 300 }: DelayedRenderProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  const childKeys = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return child.key;
    }
    return null;
  })?.join(',');

  useEffect(() => {
    if (!childKeys) setShouldRender(false);
    if (childKeys) {
      const timeout = setTimeout(() => {
        setShouldRender(true);
      }, delay);

      return () => {
        clearTimeout(timeout);
      };
    }
    return () => {};
  }, [childKeys]);

  return shouldRender ? <>{children}</> : null;
};

export const DelayedMountAndUnmount = ({
  children,
  delay = 300,
}: DelayedRenderProps) => {
  const childKeys = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return child.key;
    }
    return null;
  })?.join(',');

  const [toRender, setToRender] = useState(null);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setToRender(children);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [childKeys]);

  return <>{toRender}</>;
};
